var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-5"},[_c('v-card-title',[_vm._v("This Month")]),_c('dashboard-agents-card'),_c('v-divider'),_c('dashboard-sites-card'),_c('v-divider'),_c('dashboard-revenue-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }